import { ImageLoader } from 'next/legacy/image';

export const CalmLogoColor = { White: 'White', Gradient: 'Gradient' } as const;
type CalmLogoColorType = (typeof CalmLogoColor)[keyof typeof CalmLogoColor];

export interface CalmLogoProps {
	className?: string;
	height?: number;
	href?: string;
	color?: CalmLogoColorType;
	loader?: ImageLoader;
	preserveQueryParams?: boolean;
	'aria-label'?: string;
}
